(function() {
  'use strict';

  /* ── Slider Logic ── */
  function initSuggestionSliders() {
    document.querySelectorAll('[data-cart-suggestions]').forEach(function(container) {
      if (container.dataset.suggestionInit === 'true') return;
      container.dataset.suggestionInit = 'true';

      var slider = container.querySelector('[data-suggestion-slider]');
      var prevBtn = container.querySelector('[data-suggestion-prev]');
      var nextBtn = container.querySelector('[data-suggestion-next]');
      var slides = container.querySelectorAll('[data-suggestion-slide]');
      if (!slider || !slides.length) return;

      var currentIndex = 0;
      var isDrawer = container.classList.contains('cart-suggestions--drawer');

      function getSlidesPerView() {
        if (isDrawer) return 2;
        return window.innerWidth >= 768 ? 4 : 2;
      }

      function getMaxIndex() {
        var perView = getSlidesPerView();
        return Math.max(0, slides.length - perView);
      }

      function updateSlider() {
        if (!slides[0]) return;
        var slideWidth = slides[0].offsetWidth + 10; /* gap */
        slider.style.transform = 'translateX(-' + (currentIndex * slideWidth) + 'px)';
        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          if (currentIndex < getMaxIndex()) {
            currentIndex++;
            updateSlider();
          }
        });
      }

      /* ── Touch / Swipe ── */
      var touchStartX = 0;
      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      slider.addEventListener('touchend', function(e) {
        var touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0 && currentIndex < getMaxIndex()) { currentIndex++; }
          else if (diff < 0 && currentIndex > 0) { currentIndex--; }
          updateSlider();
        }
      }, { passive: true });

      window.addEventListener('resize', function() { updateSlider(); });
      updateSlider();
    });
  }

  /* ── Public init function (slider only - add-to-cart handled by theme natively) ── */
  window.initCartSuggestions = function() {
    initSuggestionSliders();
  };

  /* ── Init on DOM Ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initCartSuggestions);
  } else {
    window.initCartSuggestions();
  }

  /* ── Re-init after theme cart loaded (drawer first render) ── */
  document.addEventListener('theme:cart:loaded', function() {
    setTimeout(window.initCartSuggestions, 100);
  });

  /* ── Re-init after theme cart open ── */
  document.addEventListener('theme:cart:open', function() {
    setTimeout(window.initCartSuggestions, 100);
  });
})();
